export const INPUT_UOM_MAP: { [key: string]: any } = {
    'Yarn' : ['Kg'],
    'Fabric' : ['Mtr'],
    'Trim' : ['Pc', 'Kg', 'Sq Mtr', 'Mtr'],
    'Packing Material' : ['Cu Mtr', 'Mtr', 'Pc', 'Sq Cm', 'Roll', 'Gross', 'Sheet', 'Box', 'Bundle', 'Kg', 'Packet', 'Ream'],
    'Made-up' : ['Pack'],
    'Hard Good': ['Pack'],
    'Checking (Made-up)' : ['Pc'],
    'Checking (Fabric)' : ['Mtr', 'Sq Mtr'],
    'Packing (Made-up)' : ['Pc'],
    'Packing (Fabric)' : ['Mtr', 'Sq Mtr'],
    'Checking + Packing (Fabric)' : ['Mtr', 'Sq Mtr'],
    'Checking + Packing (Made-up)' : ['Pc'],
    'Blanket Stitching' : ['Mtr'],
    'Bale Packing' : ['Kg'],
    'Box Making' : ['Count'],
    'Button Fixing' : ['Count'],
    'Cutting' : ['Mtr'],
    'Dyeing' : ['Sq Mtr', 'Kg', 'Mtr'],
    'Embossing' : ['Sq Inch'],
    'Embroidery' : ['1,000 Stitch', 'Pc'],
    'Filling' : ['Pc', 'Kg'],
    'Fringe Making' : ['Mtr'],
    'Fusing' : ['Sq Mtr', 'Mtr'],
    'Hand Processing' : ['Kg'],
    'Ironing' : ['Sq Mtr', 'Mtr'],
    'Kaja Making' : ['Count'],
    'Mending' : ['Count'],
    'Overlocking' : ['Mtr'],
    'Picotin' : ['Mtr'],
    'Printing' : ['Sq Mtr', 'Mtr'],
    'Quilting' : ['Sq Mtr', 'Mtr'],
    'Rivet Fixing' : ['Count'],
    'Sanforizing' : ['Sq Mtr', 'Mtr'],
    'Special Coating' : ['Sq Mtr', 'Mtr'],
    'Special Finishing' : ['Sq Mtr', 'Kg', 'Mtr'],
    'Special Washing' : ['Kg'],
    'Stain Removing' : ['Count'],
    'Stitching' : ['Mtr'],
    'Cutting + Stitching' : ['Mtr'],
    'Cutting + Stitching + Checking' : ['Mtr', 'Pc'],
    //'Transport' : ['Cu Mtr', 'Kg'],
    'Vacuum Packing' : ['Pc'],
    'Weaving' : ['Sq Mtr', 'Mtr']
}
